const config = {
  apiBaseUrl: 'https://backend.homeslygroup.com',
  // apiBaseUrl: 'http://localhost:8080',
};

export default config;
